module.exports = __webpack_public_path__ + "static/media/8.af32846c.JPG";